export const AGENT_CHAPTER_KEY: Record<string, string> = {
  'scan-planner':            'site',
  'pre-fetch':               'site',
  'site-page-fetcher':       'site',
  'social-proof-fetcher':    'trust',
  'image-curator':           'visuals',
  'brand-synthesizer':       'customers',
  'google-citation-checker': 'google',
  'ai-citation-checker':     'assistants',
  'content-strategist':      'compiling',
  'content-lead':            'compiling',
};

export const NON_RESCAN_AGENTS = new Set(['image-curator', 'brand-synthesizer', 'content-strategist', 'content-lead']);

// A rescan spends its last couple of minutes on these, after every agent with a
// chapter has finished. Counting them keeps its bar moving instead of holding at 90.
const RESCAN_FACT_AGENTS = ['fact-page-gate', 'fact-extractor', 'fact-key-canonicalizer', 'fact-reconciler', 'fact-auditor'];

const POST_HANDOFF_AGENTS = new Set(['content-strategist']);

function progressAgents(rescan?: boolean): string[] {
  const chapterAgents = Object.keys(AGENT_CHAPTER_KEY).filter(a =>
    (rescan ? !NON_RESCAN_AGENTS.has(a) : !POST_HANDOFF_AGENTS.has(a)));
  return rescan ? [...chapterAgents, ...RESCAN_FACT_AGENTS] : chapterAgents;
}

export function estimatePctFromCompletedAgents(completedAgents: string[], rescan?: boolean): number {
  const relevantAgents = rescan ? progressAgents(true) : Object.keys(AGENT_CHAPTER_KEY);
  if (relevantAgents.length === 0) return 0;
  const done = relevantAgents.filter(a => completedAgents.includes(a)).length;
  return Math.min(90, Math.round((done / relevantAgents.length) * 90));
}

export function progressBoundsFor(completedAgents: Set<string>, rescan?: boolean): { floor: number; ceiling: number } {
  const relevant = progressAgents(rescan);
  if (relevant.length === 0) return { floor: 0, ceiling: 90 };
  const share = 90 / relevant.length;
  const done = relevant.filter(a => completedAgents.has(a)).length;
  return {
    floor: Math.round(share * done),
    ceiling: Math.round(Math.min(90, share * (done + 1))),
  };
}
